import { useEffect, useState } from "react";
import { useAuth } from "./useAuth";
import { SubscriptionStatus } from "../lib/types";
import { getSubscriptionStatus } from "../lib/helpers/setupIntentConfirmation";

const useSubscriptionStatus = (): SubscriptionStatus | null => {
  const { user, loading } = useAuth();
  const [subscriptionStatus, setSubscriptionStatus] =
    useState<SubscriptionStatus | null>(null);

  useEffect(() => {
    const checkSubscription = async () => {
      if (user === null || loading) {
        return;
      }

      try {
        const result = await getSubscriptionStatus();
        setSubscriptionStatus(result);
      } catch (error) {
        console.error("Error checking subscription:", error);
        setSubscriptionStatus(null);
      }
    };

    void checkSubscription();
  }, [loading, user]);

  return subscriptionStatus;
};

export default useSubscriptionStatus;
